import { Link } from "react-router-dom";
import { ANONYMOUS_PAGEVIEW_LIMIT } from "../helpers/constants";

/**
 * Full-screen blocking overlay shown to anonymous visitors once they
 * have used up their free pageviews.
 */
export default function LoginGate() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-xl">
        <h2 className="text-2xl font-semibold text-gray-700 mb-2">
          Please log in to continue
        </h2>
        <p className="text-gray-500 mb-6">
          {`You've viewed ${ANONYMOUS_PAGEVIEW_LIMIT} pages as a guest. Log in or create a free account to keep exploring The HUB.`}
        </p>
        <Link
          to="/login"
          className="inline-block rounded-lg bg-[var(--color-action-primary)] px-6 py-3 font-medium text-white"
        >
          Log in or Create Account
        </Link>
      </div>
    </div>
  );
}
